/** Marks simulated (demo) records everywhere they appear. */
export function DemoChip({ show = true }: { show?: boolean }) {
  return show ? (
    <span className="chip chip-demo" title="Data simulasi untuk demo, bukan tabung atau kiriman sungguhan">
      Simulasi
    </span>
  ) : null;
}
